/**
 * A component for the table header sorting functionality
 */

import PropTypes from 'prop-types';
import cx from 'classnames';
import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as DownSVG } from '../../../Assets/icons/down.svg';
import { ReactComponent as UpSVG } from '../../../Assets/icons/up.svg';
import styles from '../ReusableComponents.module.css';

function SortIcon(props) {
  const { sortOrder = '', currentlySorted = false } = props;

  if (!currentlySorted) return null;

  if (!sortOrder || sortOrder === 'DESC') {
    return (
      <SvgIcon
        component={() => (
          <DownSVG
            className={cx(styles.iconButton, {
              [styles.hiddenSort]: !currentlySorted,
            })}
          />
        )}
      >
        <div />
      </SvgIcon>
    );
  }

  if (sortOrder === 'ASC') {
    return (
      <SvgIcon
        component={() => (
          <UpSVG
            className={cx(styles.iconButton, {
              [styles.hiddenSort]: !currentlySorted,
            })}
          />
        )}
      >
        <div />
      </SvgIcon>
    );
  }

  return null;
}

export default SortIcon;

SortIcon.propTypes = {
  sortOrder: PropTypes.string,
  currentlySorted: PropTypes.bool,
};
